<template>
  <v-container class="modulos-page">

    <v-alert
        v-if="!hasAnyAccess"
        type="warning"
        border="left"
        colored-border
        elevation="2"
    >
      Você não possui acesso a nenhum módulo.
      Entre em contato com o administrador.
    </v-alert>

    <v-row v-else class="flex justify-content-center align-center mt-2">
      <v-col
          v-for="modulo in modulos"
          :key="modulo.id"
          cols="12"
          sm="6"
          md="4"
          lg="4"
      >
        <v-card
            class="modulo-card"
            :class="{ 'modulo-card--disabled': !modulo.has_access }"
            flat
        >
          <div class="modulo-card__topbar"></div>

          <div class="modulo-card__content">
            <div class="modulo-card__icon">
              <v-icon color="red darken-2" size="22">
                {{ modulo.icon || 'mdi-layers-outline' }}
              </v-icon>
            </div>

            <div class="modulo-card__body">
              <h3 class="modulo-card__title">{{ modulo.nome }}</h3>

              <!-- <p class="modulo-card__desc">
                {{ modulo.descricao || 'Aprenda os conceitos avancados do modulo com exemplos praticos e exercicios interativos.' }}
              </p> -->
            </div>

            <v-btn
                class="modulo-card__btn"
                color="red darken-2"
                depressed
                block
                large
                :disabled="!modulo.has_access"
                @click="selecionar(modulo.id)"
            >
              <span style="color: white" class="mr-2">Acessar</span>
              <v-icon style="color: white" size="18">mdi-arrow-right</v-icon>
            </v-btn>
          </div>
        </v-card>
      </v-col>
    </v-row>


  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'SelecionarModuloView',

  async created() {
    await this.buscarModulos()
  },

  computed: {
    ...mapGetters('ctrlModulos', [
      'modulos',
      'hasAnyAccess',
      'carregandoModulos'
    ])
  },

  methods: {
    ...mapActions('ctrlModulos', [
      'buscarModulos',
      'selecionarModulo'
    ]),

    async selecionar(id) {
      const resp = await this.selecionarModulo(id);

      if (resp.status === 200) {
        this.$router.push('/workflow/backlog');
      } else {
        alert(resp?.data?.message || 'Erro ao selecionar módulo');
      }
    }
  }
}
</script>

<style scoped lang="scss">
.modulos-page {
  padding-top: 16px;
  padding-bottom: 24px;
}

.modulos-header {
  margin-bottom: 18px;
}

.modulos-title {
  font-size: 34px;
  font-weight: 800;
  margin: 0;
  line-height: 1.1;
}

.modulos-subtitle {
  margin: 6px 0 0;
  font-size: 16px;
  color: #6b7280;
}

.modulo-card {
  position: relative;
  border-radius: 30px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  overflow: hidden;
}

.modulo-card__topbar {
  height: 6px;
  background: #e11d2e;
}

.modulo-card__content {
  padding: 18px 18px 16px;
}

.modulo-card__icon {
  width: 46px;
  height: 46px;
  border-radius: 12px;
  background: #fdecef;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
}

.modulo-card__title {
  margin: 0;
  font-size: 18px;
  font-weight: 800;
  color: #111827;
}

.modulo-card__desc {
  margin: 10px 0 16px;
  font-size: 14px;
  line-height: 1.45;
  color: #6b7280;
  min-height: 42px;
}

.modulo-card__btn {
  border-radius: 12px;
  text-transform: none;
  font-weight: 800;
}

.modulo-card--disabled {
  opacity: 0.45;
  filter: grayscale(1);
}
</style>